module.exports = __webpack_public_path__ + "static/img/ios_ku.1444f745.png";